import React, { useEffect, useState } from "react";
import { Form, Button, message } from "antd";
import FormSection from "./FormSection";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import AnswerForm from "./AnswerForm";

const Wrap = styled.div`
  .lite-text {
    color: #636980;
  }
`;

const AppraiseeForm = ({
  setStep,
  step,
  introductoryDetail,
  setIntroductoryDetail,
  mainSectionDetail,
  setMainSectionDetail,
  remarkSectionDetail,
  setRemarkSectionDetail,
  saveAppraiseDetails,
  setIsAddEditTemplate,
  isAddEditTemplate,
  status,
  setStatus,
  onSubmitClick,
  loading,
  draftLoading,
  scrollToTop,
  validateAll,
  setAppraisarIntroductoryDetail,
  setAppraisarMainSectionDetail,
  setAppraisarRemarkSectionDetail,
}) => {
  const [form] = Form.useForm();
  const [mainSectionError, setMainSectionError] = useState(false);

  console.log(
    "introductoryDetail",
    introductoryDetail,
    "mainSectionDetail",
    mainSectionDetail,
    "eemarkSectionDetail",
    remarkSectionDetail
  );

  const onFinish = (values) => {
    console.log("Submitted Values:", values);
    message.success("Appraisal form submitted successfully");
    form.resetFields();
  };

  const syncSection = (appraiseeList, setAppraiserSection) => {
    setAppraiserSection((prevAppraiser) => {
      const prevMap = (prevAppraiser || []).reduce((acc, item, i) => {
        acc[i] = item;
        return acc;
      }, {});

      return appraiseeList.map((appraiseeItem, i) => ({
        // keep appraiser's own formType/options/question if exists at same index
        ...(prevMap[i] || {
          question: "",
          question_placeholder: "Question",
          options: [{ optionText: "Option 1" }],
          formType: "MULIPLE_CHOICE",
          id: i + 1,
          requiredSwitch: false,
        }),
      }));
    });
  };

  // Sync all three sections whenever appraisee changes

  const syncDelete = (setter, deletedIndex) => {
    if (typeof setter === "function") {
      setter((prev) => {
        const updated = Array.isArray(prev) ? [...prev] : [];
        updated.splice(deletedIndex, 1);
        return updated;
      });
    }
  };

  // Validate that Main Questionnaire Section has at least one filled question
  const validateMainSection = () => {
    const hasAtLeastOneQuestion = mainSectionDetail?.every(
      (section) => section?.question !== ""
    );

    // mainSectionDetail?.every((section) => section?.question !== "");

    if (!hasAtLeastOneQuestion) {
      setMainSectionError(true);
      message.error(
        "Main Questionnaire Section is mandatory. Please fill all the questions."
      );
      return false;
    }

    setMainSectionError(false);
    return true;
  };

  const footerStyle = {
    position: "sticky",
    bottom: -20,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };
  useEffect(() => {
    syncSection(introductoryDetail, setAppraisarIntroductoryDetail);
  }, [introductoryDetail]);

  useEffect(() => {
    syncSection(mainSectionDetail, setAppraisarMainSectionDetail);
  }, [mainSectionDetail]);

  useEffect(() => {
    syncSection(remarkSectionDetail, setAppraisarRemarkSectionDetail);
  }, [remarkSectionDetail]);

  return (
    <Wrap>
      {/* introductoryDetail */}
      <h6 className="mb-3">Appraisee's Form</h6>
      <h6>Indroductory Section</h6>
      <p className="lite-text">
        This section is used to collect basic details of appraisee and set
        context for the appraisal. This may include information like employee
        name, role, brief note etc...
      </p>
      <section className="form_builder main_container">
        <Row className="d-flex justify-content-center">
          <Col md={10} lg={7} sm={12}>
            <FormSection
              setFullFormDetail={setIntroductoryDetail}
              fullFormDetail={introductoryDetail}
              isDisabled={status === "view"}
              onDeleteQuestion={(i) =>
                syncDelete(setAppraisarIntroductoryDetail, i)
              }
            />
          </Col>
        </Row>
      </section>

      {/* mainquestions */}
      <h6 className="mt-5">
        Main Questionnaire Section<span className="text-danger">*</span>
      </h6>
      <p className="lite-text">
        This is the core performance evaluation section. Employees rate
        themselves and answer questions related to skills, goals, and
        performance. These questions will be automatically duplicated in the
        Appraiser form so that both self-ratings and reviewer ratings can be
        compared.
      </p>
      {mainSectionError && (
        <div
          style={{
            color: "red",
            fontSize: "13px",
            marginBottom: "8px",
            marginTop: "-4px",
          }}
        >
          Please fill all the questions in this section.
        </div>
      )}
      <section
        className="form_builder main_container"
        style={{
          border: mainSectionError ? "1px solid red" : "none",
          borderRadius: mainSectionError ? "8px" : "0",
          padding: mainSectionError ? "8px" : "0",
        }}
      >
        <Row className="d-flex justify-content-center">
          <Col md={10} lg={7} sm={12}>
            <FormSection
              setFullFormDetail={(val) => {
                setMainSectionDetail(val);
                // ✅ Guard with Array.isArray before calling .some
                if (
                  Array.isArray(val) &&
                  val?.every((section) => section?.question !== "")
                ) {
                  setMainSectionError(false);
                }
              }}
              fullFormDetail={mainSectionDetail}
              isDisabled={status === "view"}
              onDeleteQuestion={(i) =>
                syncDelete(setAppraisarMainSectionDetail, i)
              }
            />
          </Col>
        </Row>
      </section>

      {/* remarks */}
      <h6 className="mt-5">Remarks & Feedback Section</h6>
      <p className="lite-text">
        This section allows the employee to share additional comments,
        challenges, achievements, or expectations. It supports open feedback
        beyond ratings.
      </p>
      <section className="form_builder main_container ">
        <Row className="d-flex justify-content-center ">
          <Col md={10} lg={7} sm={12}>
            <FormSection
              setFullFormDetail={setRemarkSectionDetail}
              fullFormDetail={remarkSectionDetail}
              isDisabled={status === "view"}
              onDeleteQuestion={(i) =>
                syncDelete(setAppraisarRemarkSectionDetail, i)
              }
            />
          </Col>
        </Row>
      </section>
      {status !== "view" && (
        <div style={footerStyle}>
          <ButtonOutlined
            className="border-0"
            onClick={() => {
              setStatus("");
              setIsAddEditTemplate(false);
            }}
          >
            Cancel
          </ButtonOutlined>
          {status !== "edit" && (
            <>
              <ButtonOutlined
                loading={draftLoading}
                onClick={() => onSubmitClick("draft")}
              >
                Save as Draft
              </ButtonOutlined>
              <ButtonOutlined
                onClick={() => {
                  scrollToTop();
                  setStep(step - 1);
                }}
              >
                Previous
              </ButtonOutlined>
            </>
          )}
          <ButtonFilled
            loading={loading}
            type="primary"
            htmlType="submit"
            onClick={() => {
              if (!validateMainSection()) return;

              if (
                mainSectionDetail?.every(
                  (section) => section?.question !== ""
                ) &&
                status !== "edit"
              ) {
                saveAppraiseDetails();
                scrollToTop();
                setStep(step + 1);
              } else if (
                mainSectionDetail?.every(
                  (section) => section?.question !== ""
                ) &&
                status === "edit"
              ) {
                if (!validateAll()) return;
                onSubmitClick("");
              }
            }}
          >
            {status === "edit" ? "Update" : "Next"}
          </ButtonFilled>
        </div>
      )}
    </Wrap>
  );
};

export default AppraiseeForm;
